<div class="button-wrapper">
  <div class="survey-actions js-survey-actions">
    <div class="survey-actions__action">
      <jui-button
        size="xl"
        [title]="vm.helpCancelActionText"
        [expand]="true"
        [disabled]="vm.helpRequestInProgress"
        color="low"
        (click)="cancelHelp()"
        [attr.data-qa]="vm.qaCancelButton"
      >{{vm.helpCancelActionText}}</jui-button>
    </div>
    @if (!vm.helpRequestSubmitted) {
      <div class="survey-actions__action">
        <jui-button
          size="xl"
          [title]="vm.helpSubmitLabel"
          [loading]="vm.helpRequestInProgress"
          [expand]="true"
          [disabled]="vm.helpRequestButtonDisabled"
          (click)="requestHelp()"
          [attr.data-qa]="vm.qaSubmitButton"
        >{{vm.helpSubmitLabel}}</jui-button>
      </div>
    }
  </div>
</div>
